/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'subscriptions': {
    width: 16,
    height: 20,
    viewBox: '0 0 16 20',
    data: '<path pid="0" d="M13.995 18.869a.54.54 0 0 0 .54-.54V1.683a.54.54 0 0 0-.54-.54H1.978a.54.54 0 0 0-.54.54V18.33c0 .297.242.539.54.539h12.017zm0 1H1.978c-.85 0-1.54-.69-1.54-1.54V1.683c0-.85.69-1.54 1.54-1.54h12.017c.85 0 1.54.69 1.54 1.54V18.33c0 .85-.69 1.539-1.54 1.539zM3.302 6.022h9.368v-1H3.302v1zm0 4.478h9.368v-1H3.302v1zm0 4.478h9.368v-1H3.302v1z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/subscriptions.js